module.exports = require("btoa");